import React from "react";
import { getQRSortIcon } from "../utils/greenMilesUtils";

const SortableHeader = ({ column, currentColumn, currentDirection, onSort, children, className = "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider", sortable = true }) => {
  const handleClick = () => {
    if (sortable && onSort) {
      onSort(column);
    }
  };

  const headerClassName = sortable ? `${className} cursor-pointer hover:bg-gray-100 transition-colors select-none` : className;

  return (
    <th className={headerClassName} onClick={handleClick}>
      <div className="flex items-center justify-between">
        <span className={column === currentColumn ? "text-blue-600 font-semibold" : ""}>{children}</span>
        {sortable && <div className="ml-2 flex-shrink-0">{getQRSortIcon(column, currentColumn, currentDirection)}</div>}
      </div>
    </th>
  );
};

export default SortableHeader;
